import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { updateStyles } from '../../../../redux/slices/userActivity';

export default function FontSize() {

    const { selectedUserActivity, userActivities, selectedComponent } = useSelector((state) => state.userActivity);
    const [styles, setStyles] = useState({});
    const [fontSize, setFontSize] = useState(0)
    const dispatch = useDispatch()
// console.log(styles[selectedComponent.name]);
// console.log(fontSize);
    useEffect(() => {
        if(styles[selectedComponent.name] === undefined) return
        styles[selectedComponent.name].fontSize ? setFontSize(styles[selectedComponent.name].fontSize) : setFontSize('1rem')
     }, [selectedComponent, selectedUserActivity, userActivities[selectedUserActivity], styles ])
 
    useEffect(() => {
        if (Object.keys(userActivities[selectedUserActivity]).length > 1) {
            setStyles(userActivities[selectedUserActivity].theme_id.styles.styles);
        }
    }, [selectedUserActivity, Object.keys(userActivities[selectedUserActivity]).length,
     userActivities[selectedUserActivity]]);

    const handleFontSizeChange = e => {
        const value = e.target.value
        if (Object.keys(userActivities[selectedUserActivity]).length > 1) {
            let tempStyles = { ...styles };
            tempStyles[selectedComponent.name] = {
                ...styles[selectedComponent.name],
                fontSize: value,
            };
            setStyles(tempStyles);
            dispatch(
                updateStyles({
                    selectedActivityIdx: selectedUserActivity,
                    style: tempStyles,
                })
            );
        }
    }

    return (
        <div className=' font-size-editor mr-4 font-family-select'>
            <select value={fontSize} className='text_editor_item' onChange={e => handleFontSizeChange(e)} >
                {fontSizes.map(fontSize =>
                    <option key={fontSize.px} value={fontSize.rem} > {fontSize.px} </option>
                )}
            </select>
            <img src='/assets/icons/down-arrow.svg' className='select-icon' />
        </div>
    )
}

const fontSizes = [
    {
        px: 16,
        rem: '1rem'
    },
    {
        px: 17,
        rem: '1.063rem'
    },
    {
        px: 18,
        rem: '1.125rem'
    },
    {
        px: 19,
        rem: '1.188rem'
    },
    {
        px: 20,
        rem: '1.25rem'
    },
    {
        px: 22,
        rem: '1.375rem'
    },
    {
        px: 24,
        rem: '1.5rem'
    },
    {
        px: 26,
        rem: '1.625rem'
    },

]
